<template>
  <div>
    <head-nav-bar title="筛查记录" :fixed="true" />
    <div class="mt-header-nav">
      <van-form @submit="onSearchSubmit">
        <van-field name="radio">
          <template #input>
            <van-radio-group
              v-model="searchType"
              @change="onSearchTypeChange"
              direction="horizontal"
            >
              <van-radio name="1">身份证</van-radio>
              <van-radio name="2">就诊卡号</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-model="keyword" placeholder="请填写号码" required />
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit"
            >搜索</van-button
          >
        </div>
      </van-form>
    </div>
    <div class="screening-form">
      <ScreeningForm v-if="!notInfo" ref="screeningForm" :isPage="false" />
      <div v-else>
        <van-empty description="未查询到筛查记录" />
      </div>
    </div>
  </div>
</template>
<script>
import ScreeningForm from "./Form.vue";
// import { stringTrim } from "@/utils/common";
import {
  Form,
  Field,
  Button,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Popup,
  Picker,
  Tag,
  Switch,
  Overlay,
  Row,
  Col,
  Toast,
  Empty
} from "vant";
export default {
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Tag.name]: Tag,
    [Switch.name]: Switch,
    [Overlay.name]: Overlay,
    [Col.name]: Col,
    [Row.name]: Row,
    ScreeningForm,
    [Empty.name]: Empty
  },
  data() {
    return {
      searchType: "1",
      keyword: "",
      info: {},
      notInfo: false
    };
  },
  methods: {
    onSearchTypeChange() {
      this.keyword = "";
    },
    onSearchSubmit() {
      if (!this.keyword) {
        const text = this.searchType == 1 ? "身份证号" : "就诊卡号";
        Toast("请输入" + text);
        return;
      }
      const field =
        this.searchType == 1 ? "PatientIdentityNo" : "DiagnoseCardNo";
      const pramas = {
        [field]: this.keyword
      };
      this.$post("GetFormRecordInfoFromWx", pramas)
        .then(res => {
          this.notInfo = false;
          this.info = res.Data;
          this.$nextTick(() => {
            this.$refs.screeningForm.setData(res.Data);
          });
        })
        .catch(() => {
          this.notInfo = true;
        });
    }
  }
};
</script>
